module.exports = __webpack_public_path__ + "static/media/bg_all_caught.d8a7d36c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/bg_all_caught.svg
// module id = 1911
// module chunks = 0